import { TradeBreakdown } from '@/components/features/trade/TradeBreakdown/TradeBreakdown';
import type { TradeBreakdown as TradeBreakdownType } from '@/hooks/trade/useTradeBreakdown';
import { TradeCurrency, TradeCurrencyError } from './TradeCurrency';
import { TradeSide } from '../schema';

interface TradeMarketBuyFormProps {
  assetId?: string;
  isMutualFund?: boolean;
  isFractionable?: boolean;
  tradeBreakdown: TradeBreakdownType;
}

export const TradeMarketBuyForm = ({
  assetId,
  isMutualFund,
  isFractionable,
  tradeBreakdown,
}: TradeMarketBuyFormProps) => {
  return (
    <div className="flex flex-col gap-2">
      <TradeCurrency
        side={TradeSide.BUY}
        assetId={assetId}
        isFractionable={isFractionable}
        showUnitToggler={!isMutualFund}
      />

      <div className="mb-2">
        <TradeCurrencyError />
      </div>

      {!isMutualFund && <TradeBreakdown tradeBreakdown={tradeBreakdown} />}
    </div>
  );
};
